<script setup lang="ts">
import { EntityRatingCriteriaSet } from '~/components/entity/rating-criteria-set'
import { useRating } from '~/composables/useRating'
import type { IRatingCriteriaSet } from '~/composables/useRating'

interface Props {
  criteriaSet: IRatingCriteriaSet
}

interface Emits {
  (e: 'ratingsChanged', ratings: Record<number, number>): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const { getRatingCriteriaSet } = useRating()

const { data: criteriaSetDetails, pending: criteriaSetLoading } = getRatingCriteriaSet(
  props.criteriaSet.id
)

const criteriaList = computed(() => {
  return criteriaSetDetails.value?.data?.criteria || props.criteriaSet.criteria || []
})

const criteriaRatings = ref<Record<number, number>>({})

// EntityRatingCriteriaSet mutates through v-model; this widget still needs to
// notify its own caller via the ratingsChanged event.
watch(criteriaRatings, (value) => emit('ratingsChanged', { ...value }), { deep: true })
</script>

<template>
  <EntityRatingCriteriaSet
    v-if="!criteriaSetLoading"
    v-model="criteriaRatings"
    :criteria="criteriaList"
  />

  <div v-else class="grid grid-cols-1 gap-4 md:grid-cols-2">
    <div v-for="i in 4" :key="i" class="animate-pulse space-y-2">
      <div class="h-4 w-20 rounded bg-gray-200" />
      <div class="h-4 w-3/4 rounded bg-gray-200" />
      <div class="h-3 w-full rounded bg-gray-200" />
    </div>
  </div>
</template>
